module.exports = __webpack_public_path__ + "img/LogoProsa_Color.df21bc83.png";